module.exports = __webpack_public_path__ + "static/media/3-dots.3b864f56.svg";